export type Goal = 'lighter' | 'protein' | 'veggies' | 'dairy';

export const GOALS: { key: Goal; label: string }[] = [
  { key: 'lighter', label: 'Легче' },
  { key: 'protein', label: 'Больше белка' },
  { key: 'veggies', label: 'Больше овощей' },
  { key: 'dairy', label: 'Молочное' },
];
